/* src/app/components/controls/sem-progress-bar/sem-progress-bar.component.css */
:host {
  display: contents;
}
.sem-progress-bar-wrap {
  display: contents;
}
.sem-progress-bar {
  display: flex;
  align-items: flex-start;
  width: 100%;
  padding: 24px 19px 17px 19px;
  box-sizing: border-box;
}
.sem-progress-bar__step {
  position: relative;
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-width: 0;
}
.sem-progress-bar__connector {
  position: absolute;
  top: 16px;
  left: -50%;
  width: 100%;
  height: 2px;
  background-color: #d0d5dd;
  z-index: 0;
}
.sem-progress-bar__step.done .sem-progress-bar__connector,
.sem-progress-bar__step.current .sem-progress-bar__connector {
  background-color: var(--sem-progress-bar-current-color, var(--wg-accent, #3b82f6));
}
.sem-progress-bar__circle {
  position: relative;
  z-index: 1;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  border: 2px solid #d0d5dd;
  color: #98a2b3;
  font-weight: 600;
  font-size: 16px;
  flex-shrink: 0;
}
.sem-progress-bar__step.done .sem-progress-bar__circle {
  background-color: var(--sem-progress-bar-done-color, #344054);
  border-color: var(--sem-progress-bar-done-color, #344054);
  color: #ffffff;
}
.sem-progress-bar__step.current .sem-progress-bar__circle {
  border-color: var(--sem-progress-bar-current-color, var(--wg-accent, #3b82f6));
  border-width: 2px;
  box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px var(--sem-progress-bar-current-color, var(--wg-accent, #3b82f6));
  color: var(--sem-progress-bar-done-color, #344054);
  background-color: #ffffff;
}
.sem-progress-bar__label {
  margin-top: 10px;
  font-size: 15px;
  line-height: 1.3;
  color: #667085;
  font-weight: 400;
  max-width: 156px;
}
.sem-progress-bar__step.current .sem-progress-bar__label {
  font-weight: 600;
  color: var(--sem-progress-bar-done-color, #344054);
}
.sem-progress-bar__check {
  font-size: 17px;
  line-height: 1;
}
/*# sourceMappingURL=sem-progress-bar.component.css.map */
